import { motion } from "framer-motion";
import { ArrowRight, CalendarCheck, Globe, HeartHandshake, UserCheck } from "lucide-react";
import { Button } from "../ui/button";

const HIGHLIGHTS = [
    { icon: HeartHandshake, text: "Supportive, learner-centred online lessons" },
    { icon: UserCheck, text: "Personalised to your child's grade, ability and curriculum" },
    { icon: Globe, text: "Families welcome in South Africa, the UK and the US" },
    { icon: CalendarCheck, text: "Free introductory consultation for parents" },
];

export const About = () => (
    <section id="about" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-20 lg:py-28" data-testid="about-section">
        <div className="grid items-center gap-14 lg:grid-cols-12">
            <motion.div
                className="lg:col-span-7"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <p className="text-xs font-bold tracking-widest text-sun uppercase">About YNova Education</p>
                <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                    Better English. <span className="text-sun italic">Brighter Future.</span>
                </h2>
                <p className="mt-5 text-base text-mist sm:text-lg">
                    YNova Education provides supportive online English tutoring for primary school children in
                    Grades 1–6, helping young learners grow as readers, writers and communicators.
                </p>
                <p className="mt-4 text-base text-mist sm:text-lg">
                    Every child learns differently, so lessons are personalised to your child's grade, current
                    ability and school curriculum — with encouragement, structure and steady practice at the heart
                    of every session.
                </p>
                <p className="mt-4 text-base text-mist sm:text-lg">
                    Parents are invited to start with a free introductory consultation: a friendly conversation
                    about your child's needs, with no obligation to continue.
                </p>
                <Button asChild size="lg" className="mt-8 rounded-full px-7 font-bold shadow-xl shadow-sun/25 transition-transform duration-200 hover:scale-105">
                    <a href="#contact" data-testid="about-book-consultation-btn">
                        Book a Free Introductory Consultation
                        <ArrowRight className="ml-2 h-5 w-5" />
                    </a>
                </Button>
            </motion.div>
            <motion.div
                className="lg:col-span-5"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
            >
                <div className="rounded-3xl border border-ground-line/70 bg-ground-soft/50 p-8" data-testid="about-highlights-card">
                    <p className="font-heading text-lg font-bold text-sun">Why parents choose YNova</p>
                    <ul className="mt-6 space-y-5">
                        {HIGHLIGHTS.map((item) => (
                            <li key={item.text} className="flex items-start gap-4">
                                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sun/15 text-sun">
                                    <item.icon className="h-5 w-5" />
                                </span>
                                <p className="pt-2 text-sm leading-relaxed text-mist">{item.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </motion.div>
        </div>
    </section>
);
